import React from 'react';
import { connect } from 'react-redux';
import UsersStatsMPGTBWidget from "../Widgets/UsersStats";
import GodfatherLevelsWidget from "../Widgets/GodfatherLevels";
import '../index.css';

const GodfatherDashboard = () => (
    <div id="MPGGodfather">
        <header className="content-header">
            <h1>
                Dashboard
                <small>Parainage</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-handshake-o"/> Parainage</li>
            </ol>
        </header>
        <section className="content">
            <div className="row">
                <div className="col-md-12">
                    <UsersStatsMPGTBWidget />
                </div>
                <div className="col-md-12">
                    <GodfatherLevelsWidget />
                </div>
            </div>
        </section>
    </div>
);

export default connect(
    state => ({}),
    dispatch => ({ dispatch }),
)(GodfatherDashboard);



// WEBPACK FOOTER //
// ./src/pages/Other/Godfather/Dashboard/index.js